import React, { useState } from 'react'
import {StepData} from './ChapterTaskDrawer';
import {Box, Button, TextField, Typography} from "@mui/material";
import {deleteButtonIcon} from '../../../../../../../../icon/delete-button-preview';
import videoImg from '../../../../../../../../assets/images/video.svg';
import useVideoValidation from '../../../../../../../../hooks/useVideoValidation';
import document from '../../../../../../../../assets/icons/document.svg';
import {courseService} from "../../../../../../../../services/course.service";
import * as Yup from 'yup';
import {Field, Form, Formik} from "formik";

type StepTwoProps = {
    data: {
        video: string;
        instructions: string;
        resources: string;
        file_name: string | undefined;
        file_extension: string | undefined;
    };
    onDataChange: (data: Partial<StepData>) => void;
    nextStep: () => void;
};


const validationSchema = Yup.object({
    instructions: Yup.string().required('Требуется инструкция'),
});

const StepTwoTask: React.FC<StepTwoProps> = ({data, onDataChange, nextStep}) => {
  const { validateVideo, ErrorModal } = useVideoValidation();
  const [isUploading, setUploading] = useState(false);
    return (
        <div>
            <Formik
                key={data.video + data.resources + data.file_name + data.file_extension + data.instructions}
                initialValues={{
                    instructions: data.instructions || '',
                    video: data.video || '',
                    resources: data.resources || '',
                    file_name: data.file_name || '',
                    file_extension: data.file_extension || '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    onDataChange({step2: values});
                    setSubmitting(false);
                    nextStep();
                }}
            >
                {({ setFieldValue, errors, touched, values }) => (
                    <Form>
                        <ErrorModal/>
                        <div className="step-one-title">
                            Загрузить видео
                        </div>
                        <div className="step-one-subtitle">
                            Все файлы должны быть в качестве не ниже 720p и размером не более 4,0 ГБ.
                        </div>
                        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', mb: 2}}>
                          {isUploading && (
                            <div className="loader-container">
                              <p>Идет загрузка...</p>
                            </div>
                          )}
                          {values.video ? (
                                <Box sx={{position: 'relative'}}>
                                    <div className="video-preview">
                                        <video className='vid-preview' src={values.video} controls/>
                                        <button className="delete-button"
                                                onClick={() => {
                                                    setFieldValue('video', '');
                                                    onDataChange({step2: {...data, video: ''}});
                                                }}
                                        >
                                            {deleteButtonIcon}
                                        </button>
                                    </div>
                                </Box>
                            ) : (
                                <Box sx={{display: 'flex', alignItems: 'center', gap: '12px', pt: '12px'}}>
                                    <div className={`file-select ${touched.video && errors.video ? 'file-select-error' : ''}`}>
                                        {!data.video && <img src={videoImg} alt="default"/>}
                                        <label htmlFor="video">Загрузить видео</label>
                                        {errors.video && touched.video && <div>{errors.video}</div>}
                                        <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            id="video"
                                            onChange={async (event) => {
                                                if (event.target.files && event.target.files[0]) {
                                                    const file = event.target.files[0];
                                                    const errorMessage = await validateVideo(file);
                                                  if (!errorMessage) {
                                                    const formData = new FormData();
                                                    formData.append('file', file);
                                                    setUploading(true);
                                                    try {
                                                      const response = await courseService.loadVideo(formData);
                                                      setFieldValue('video', response.data.url);
                                                    } catch (error) {
                                                      console.error('Ошибка при загрузке видео', error);
                                                    } finally {
                                                      setUploading(false);
                                                    }
                                                  }
                                                }
                                            }}
                                        />
                                    </div>
                                </Box>
                            )}
                        </Box>
                        <div className="step-one-title">
                            Инструкции к заданию
                        </div>
                        <div className="step-one-subtitle">
                            Опишите что необходимо сделать в данном задании.
                        </div>
                        <Field
                            as={TextField}
                            variant="outlined"
                            placeholder="Введите инструкции"
                            name="instructions"
                            error={touched.instructions && Boolean(errors.instructions)}
                            helperText={touched.instructions && errors.instructions}
                            className="without-label"
                        />
                        <div className="step-one-title">
                            Ресурсы для скачивания
                        </div>
                        <div className="step-one-subtitle">
                            Ресурс — это документ любого типа, который может использоваться студентами во время лекции.
                            Этот
                            файл будет отображаться в качестве дополнительного материала к лекции. Убедитесь, чтобы
                            текст
                            документа был разборчивым, а размер файла не превышал 1 ГБ.
                        </div>
                        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', mb: 2}}>
                            {values.resources ? (
                                <Box sx={{display: 'flex', alignItems: 'center', gap: '12px', paddingTop: '10px'}}>
                                    <img src={document} alt="DocumentIcon"/>
                                    <Typography fontWeight={600} color={'black'} fontSize={16}>
                                        {values.file_name.length > 30
                                            ? `${values.file_name.substring(0, 26)}...${values.file_name.slice(-4)}.pptx`
                                            : `${values.file_name}${values.file_extension}`}
                                    </Typography>
                                    <Button variant="text"
                                            sx={{color: '#0573E4', fontSize: '15px', textTransform: 'none'}}
                                            onClick={() => {
                                                setFieldValue('resources', '');
                                                setFieldValue('file_name', '');
                                                setFieldValue('file_extension', '');
                                                onDataChange({step2: {...data, resources: '', file_name: '', file_extension: ''}});
                                            }}>
                                        Удалить
                                    </Button>
                                </Box>
                            ) : (
                                <Box sx={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                                    <div className={`file-select ${touched.resources && errors.resources ? 'file-select-error' : ''}`}>
                                        {!values.resources && <img style={{opacity: 0.7}} src={document} alt="default"/>}
                                        <label htmlFor="resources">Загрузить документ</label>
                                        {errors.resources && touched.resources && <div>{errors.resources}</div>}
                                        <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            id="resources"
                                            onChange={async (event) => {
                                                if (event.target.files && event.target.files[0]) {
                                                    const file = event.target.files[0];
                                                    const reader = new FileReader();
                                                    reader.readAsDataURL(file);
                                                    reader.onload = async () => {
                                                        const base64 = reader.result as string;
                                                        const fileName = file.name;
                                                        const fileExtension = fileName.split('.').pop();
                                                        try {
                                                            const response = await courseService.loadFile(base64, fileName, fileExtension);
                                                            const fileURL = response.data.image;
                                                            setFieldValue('resources', fileURL);
                                                            setFieldValue('file_name', fileName);
                                                            setFieldValue('file_extension', fileExtension);
                                                        } catch (error) {
                                                            console.error('Ошибка при загрузке файла', error);
                                                        }
                                                    };
                                                } else {
                                                    console.error("Файл не выбран");
                                                }
                                            }}
                                        />
                                    </div>
                                </Box>
                            )}
                        </Box>
                        <div className="chapter-drawer-footer-Lacture">
                            <Button
                                variant="contained"
                                type="submit">

                                Далее
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default StepTwoTask;
